import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import { GET_BOOKING } from 'store/queries';
import { Spinner } from 'admin-components/components';
import { Row, Column } from 'components/shared/Layout';
import TicketOptions from './TicketOptions';
import { DETAILS_CAPTURED } from 'constants/booking';

const Index = ({
  bookingReference,
  passengerLastName,
  selectedMethod,
  setSelectedMethod,
  allowedMethods,
  passengerEmails,
  selectedEmails,
  setSelectedEmails,
  hasSNCBTicketsUnavailable = false
}) => {
  const { data, loading } = useQuery(GET_BOOKING, {
    variables: {
      reference: bookingReference
    },
    initialFetchPolicy: 'cache-only',
    errorPolicy: 'ignore'
  });

  if (loading) {
    return (
      <Row>
        <Column justifyContent="center">
          <Spinner />
        </Column>
      </Row>
    );
  }

  return (
    <TicketOptions
      selectedMethod={selectedMethod}
      setSelectedMethod={setSelectedMethod}
      detailsCaptured={data?.booking?.detailsCaptured === DETAILS_CAPTURED.CAPTURED}
      bookingReference={bookingReference}
      passengerLastName={passengerLastName}
      allowedMethods={allowedMethods}
      passengerEmails={passengerEmails}
      selectedEmails={selectedEmails}
      setSelectedEmails={setSelectedEmails}
      booking={data?.booking}
      hasSNCBTicketsUnavailable={hasSNCBTicketsUnavailable}
    />
  );
};

Index.displayName = 'TicketOptionsIndex';

Index.propTypes = {
  bookingReference: PropTypes.string,
  passengerLastName: PropTypes.string,
  selectedMethod: PropTypes.string,
  setSelectedMethod: PropTypes.func,
  allowedMethods: PropTypes.arrayOf(PropTypes.string),
  passengerEmails: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedEmails: PropTypes.arrayOf(PropTypes.string).isRequired,
  setSelectedEmails: PropTypes.func.isRequired,
  hasSNCBTicketsUnavailable: PropTypes.bool
};

export default Index;
